export const messages = {
  en: {
    assetImportLog: {
      title: 'Batch Import Log',
      logId: 'Import ID',
      logTypeName: 'Import Type',
      waitCount: 'Pending Count',
      successCount: 'Success Count',
      errorCount: 'Failed Count',
      state: 'Status',
      stateW: 'Pending',
      stateC: 'Completed',
      stateP: 'Processing',
      createTime: 'Import Time',
      remark: 'Remark',
      fetchError: 'Failed to fetch import logs'
    }
  },
  zh: {
    assetImportLog: {
      title: '批量导入日志',
      logId: '导入编号',
      logTypeName: '导入类型',
      waitCount: '待导入数',
      successCount: '成功数量',
      errorCount: '失败数量',
      state: '状态',
      stateW: '待导入',
      stateC: '已完成',
      stateP: '处理中',
      createTime: '导入时间',
      remark: '备注',
      fetchError: '獲取導入日誌失敗'
    }
  },
  'zh-TW': {
    assetImportLog: {
      title: '批量導入日誌',
      logId: '導入編號',
      logTypeName: '導入類型',
      waitCount: '待導入數',
      successCount: '成功數量',
      errorCount: '失敗數量',
      state: '狀態',
      stateW: '待導入',
      stateC: '已完成',
      stateP: '處理中',
      createTime: '導入時間',
      remark: '備註',
      fetchError: '獲取導入日誌失敗'
    }
  }
}